import { isAxiosError } from "axios";
import { notification } from "antd";

const GENERIC_ERROR = "Došlo je do neočekivane greške. Pokušajte ponovo.";
const NETWORK_ERROR =
  "Nije moguće povezati se sa serverom. Provjerite internet konekciju.";

// Used when the response has no message from the API (e.g. it came from a
// proxy in front of the backend).
const httpStatusMessages: Record<number, string> = {
  400: "Zahtjev nije ispravan.",
  401: "Niste prijavljeni ili je sesija istekla. Prijavite se ponovo.",
  403: "Nemate pravo pristupa ovoj akciji.",
  404: "Traženi podatak nije pronađen.",
  413: "Fajl ili podaci su preveliki za slanje.",
  500: "Došlo je do greške na serveru. Pokušajte ponovo.",
  502: "Server trenutno nije dostupan. Pokušajte kasnije.",
  503: "Server trenutno nije dostupan. Pokušajte kasnije.",
  504: "Server nije odgovorio na vrijeme. Pokušajte ponovo.",
};

export const getErrorMessage = (err: unknown): string => {
  if (!isAxiosError(err)) {
    return GENERIC_ERROR;
  }
  if (!err.response) {
    return NETWORK_ERROR;
  }
  const data = err.response.data as { code?: string; message?: unknown };
  if (data && data.code && typeof data.message === "string") {
    return data.message;
  }
  return httpStatusMessages[err.response.status] || GENERIC_ERROR;
};

// `title` says what failed, the description says why (from the API when available).
export const showErrorNotification = (title: string, err?: unknown) => {
  notification.error({
    message: title,
    description: err === undefined ? undefined : getErrorMessage(err),
  });
};
